export default {"src":"/_next/static/media/LUV.dad19f00.svg","height":18,"width":18};